const doc = [({"en":({"js":({"admin":({"activities":({"live":({"agenda":({"item_types":({"election":({"index":({"ballot":"Ballot:"})})})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;